module.exports = __webpack_public_path__ + "static/img/4.45b9238.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/4.png
// module id = VujQ
// module chunks = 0